import { updateTemplate } from '@/api/services/templates';
import { DifficultyLevel } from '@/components/Template/types';
import { AxiosError } from 'axios';

type HandleTemplateUpdateParams = {
  templateId: string;
  name: string;
  description: string;
  difficulty: DifficultyLevel;
  items: any;
  setIsVisible: (visible: boolean) => void;
  goBack: () => void;
  showNotification: (options: {
    type: 'success' | 'error';
    title: string;
    message: string;
  }) => void;
};

export const handleTemplateUpdateUtil = async ({
  templateId,
  items,
  name,
  description,
  difficulty,
  setIsVisible,
  showNotification,
  goBack,
}: HandleTemplateUpdateParams) => {
  try {
    await updateTemplate(templateId, { name, description, difficulty, items });
    showNotification({
      type: 'success',
      title: `Die Vorlage ${name} wurde gespeichert.`,
      message: '',
    });
    setIsVisible(false);
    goBack();
  } catch (error) {
    const axiosError = error as AxiosError<any>;
    setIsVisible(false);
    showNotification({
      type: 'error',
      title: axiosError.response?.data?.message?.includes('duplicate')
        ? 'Vorlage mit diesem Namen existiert bereits'
        : 'Fehler beim Speichern der Vorlage',
      message: '',
    });
  }
};
